export default __webpack_public_path__ + "static/media/login.f072237e.png";